type Listener = () => void;

const displayById = new Map<string, number>();
const listeners = new Set<Listener>();

/** Rack FOUP count driven by StockerTransferAnim (may lead live inventory during handoff). */
export const stockerRackDisplayStore = {
  get(id: string): number | undefined {
    return displayById.get(id);
  },

  has(id: string): boolean {
    return displayById.has(id);
  },

  set(id: string, count: number) {
    const next = Math.max(0, Math.floor(count));
    const prev = displayById.get(id);
    if (prev === next) return;
    displayById.set(id, next);
    listeners.forEach((l) => l());
  },

  clear(id: string) {
    if (displayById.delete(id)) {
      listeners.forEach((l) => l());
    }
  },

  reset() {
    if (displayById.size === 0) return;
    displayById.clear();
    listeners.forEach((l) => l());
  },

  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
